e<template>
	<div style="height: 100vh; display: flex; flex-direction: column; padding: 20px; box-sizing: border-box;">
		<div class="notice-board" v-loading="noticeLoading">
			<div class="notice-board__header">
				<div class="notice-board__title">最新公告</div>
				<div class="notice-board__time">{{ formatDateTime(latestNotice && latestNotice.createTime) }}</div>
			</div>
			<div v-if="latestNotice" class="notice-board__body" @click="handleOpenNoticeDetail">
				<div class="notice-board__headline">{{ formatCellText(latestNotice.title) }}</div>
				<div class="notice-board__content">{{ getNoticePreview(latestNotice.content) }}</div>
				<div class="notice-board__action">点击查看详情</div>
			</div>
			<div v-else class="notice-board__empty">暂无公告</div>
		</div>

		<!-- 上方信息卡 -->
		<div class="flexs"
			style="height: 174px; border-radius: 8px; background-color: #fff; padding: 40px; flex-shrink: 0; margin-top: 16px;">
			<el-image :src="store.imageUrl" fit="contain" style="width: 100px; height: 100px;"></el-image>
			<div style="padding-left: 100px; padding-right: 120px;">
				<div class="flexc" style="font-size: 14px;">
					<div style="color: #86909C;">店铺名称:</div>
					<div style="padding-left: 12px; padding-right: 12px; flex: 1;">{{ store.storeName || '--' }}</div>
					<!-- <div style="color: #F79800;">修改</div> -->
				</div>
				<div class="flexb" style="font-size: 14px; margin-top: 10px;">
					<div style="color: #86909C;">营业时间:</div>
					<div style="padding-left: 12px; padding-right: 12px;">
						{{ store.startBusinessTime || '--' }} - {{ store.endBusinessTime || '--' }}
					</div>
					<!-- <div style="color: #F79800;">修改</div> -->
				</div>
			</div>
			<div>
				<div class="flexb" style="font-size: 14px;">
					<div style="color: #86909C;">营业资质:</div>
					<!-- 可点击的“已上传”标签 -->
					<div class="flexc"
						:style="{ marginLeft: '12px', marginRight: '12px', height: '20px', width: '52px', borderRadius: '2px', backgroundColor: store.businessLicenseUrl ? '#00B42A' : '#F79800', color: '#fff', fontSize: '12px', cursor: store.businessLicenseUrl ? 'pointer' : 'default' }"
						@click="store.businessLicenseUrl && handlePreviewLicense()">
						{{ store.businessLicenseUrl ? '已上传' : '未上传' }}
					</div>
				</div>

				<div class="flexb" style="font-size: 14px; margin-top: 10px;">
					<div style="color: #86909C;">联系电话:</div>
					<div style="padding-left: 12px; padding-right: 12px;">{{ store.contactPhoneNo || '--' }}</div>
					<!-- <div style="color: #F79800;">修改</div> -->
				</div>
			</div>
			<div style="padding-left: 100px; padding-right: 120px;">
				<div class="flexc" style="font-size: 14px;">
					<div style="color: #86909C;">店铺状态:</div>
					<div style="padding-left: 12px; padding-right: 12px; flex: 1;">
						{{ isOnline ? "在线" : "下线" }}
					</div>
					<i v-if="isOnline" class="el-icon-open" style="font-size: 28px; color: #F79800;"
						@click="handleToggleStatus(true)"></i>
					<i v-if="!isOnline" class="el-icon-turn-off" style="font-size: 28px;color: #86909C"
						@click="handleToggleStatus(false)"></i>

				</div>

			</div>
		</div>

		<!-- 下方盒子 -->
		<div
			style="flex: 1; margin-top: 16px; background-color: #fff; border-radius: 8px; padding: 20px; box-sizing: border-box;">
			<div style="padding: 20px;">
				<div class="flexs" style="font-size: 14px;">
					<div style="height: 32px; width: 88px; margin-right: 12px; cursor: pointer;"
						:class="['flexc', activeTab === 0 ? 'select' : '']" @click="activeTab = 0">基本信息</div>
					<div style="height: 32px; width: 88px; cursor: pointer;"
						:class="['flexc', activeTab === 1 ? 'select' : '']" @click="activeTab = 1">配送信息</div>
				</div>
			</div>

			<!-- 基本信息 -->
			<div v-if="activeTab === 0">
				<el-form :model="store" ref="basicForm" label-width="170px">
					<el-form-item label="店铺名称" prop="storeName">
						<el-input v-model="store.storeName" placeholder="请输入您的店铺名称" clearable
							style="width: 455px;"></el-input>
					</el-form-item>
					<el-form-item label="店铺类别" prop="storeTypeId">
						<el-select v-model="store.storeTypeId" placeholder="请选择店铺类别" clearable style="width: 455px;">
							<el-option v-for="item in storeTypeOptions" :key="item.value" :label="item.label"
								:value="item.value" />
						</el-select>
					</el-form-item>
					<el-form-item label="联系人姓名" prop="creator">
						<el-input v-model="store.creator" placeholder="请输入联系人姓名" clearable
							style="width: 455px;"></el-input>
					</el-form-item>
					<el-form-item label="联系电话" prop="contactPhoneNo">
						<el-input v-model="store.contactPhoneNo" placeholder="请输入您的联系电话" clearable
							style="width: 455px;"></el-input>
					</el-form-item>
					<el-form-item label="营业时间" prop="businessTime">
						<el-time-picker v-model="store.startBusinessTime" format="HH:mm:ss" value-format="HH:mm:ss"
							placeholder="请选择起始时间" :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
							style="width: 160px;" />
						<span style="margin: 0 10px;">至</span>
						<el-time-picker v-model="store.endBusinessTime" format="HH:mm:ss" value-format="HH:mm:ss"
							placeholder="请选择结束时间" :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
							style="width: 160px;" />
					</el-form-item>
					<el-form-item label="地址" prop="address">
						<div class="address-row">
							<el-cascader v-model="address" class="address-cascader" :options="addressOptions"
								:props="{ expandTrigger: 'hover' }" @change="handleChangeAddress"></el-cascader>
							<el-input v-model="store.address" class="address-input" placeholder="请输入详细地址" clearable />
							<el-button type="primary" plain @click="openMapPicker">地图选点</el-button>
						</div>
					</el-form-item>
					<el-form-item label="公告" prop="bulletin">
						<el-input type="textarea" placeholder="请输入公告，最多不超过 200 字。" v-model="store.bulletin"
							maxlength="200" show-word-limit style="width: 455px;"></el-input>
					</el-form-item>
					<!-- 图片上传：关键部分 -->
					<!-- 店铺图片 -->
					<el-form-item label="店铺图片" prop="shopImg">
						<el-upload ref="uploadShopImg" action="#" :http-request="customUploadHandler"
							:on-remove="(file) => handleRemove(file, 'shopImg')" :on-preview="handlePictureCardPreview"
							:on-exceed="(files, fileList) => handleUploadExceed(files, fileList, 'shopImg')"
							:file-list="shopImgFileList" list-type="picture-card" :limit="1"
							:before-upload="beforeUpload" accept="image/jpeg,image/jpg,image/png"
							:data="{ uploadType: 'shopImg' }">
							<i class="el-icon-camera-solid" style="font-size: 16px; color: #fff;"></i>
						</el-upload>
						<el-button v-if="shopImgFileList.length" type="text" class="reupload-btn"
							@click="openUploadDialog('shopImg')">重新上传</el-button>

						<!-- 大图预览 -->
						<el-dialog :visible.sync="dialogVisible">
							<img width="100%" :src="dialogImageUrl" alt="" />
						</el-dialog>
					</el-form-item>

					<!-- 营业资质 -->
					<el-form-item label="营业资质" prop="businessLicenseUrl">
						<el-upload ref="uploadLicense" action="#" :http-request="customUploadHandler"
							:on-remove="(file) => handleRemove(file, 'license')" :on-preview="handlePictureCardPreview"
							:on-exceed="(files, fileList) => handleUploadExceed(files, fileList, 'license')"
							:file-list="licenseFileList" list-type="picture-card" :limit="1"
							:before-upload="beforeUpload" accept="image/jpeg,image/jpg,image/png"
							:data="{ uploadType: 'license' }">
							<i class="el-icon-camera-solid" style="font-size: 16px; color: #fff;"></i>
						</el-upload>
						<el-button v-if="licenseFileList.length" type="text" class="reupload-btn"
							@click="openUploadDialog('license')">重新上传</el-button>

						<!-- 共用大图预览 -->
						<el-dialog :visible.sync="dialogVisible">
							<img width="100%" :src="dialogImageUrl" alt="" />
						</el-dialog>
					</el-form-item>
					<el-form-item> <el-button :loading="formLoading" class="confirm-btn"
							@click="submitForm('basicForm')">保存</el-button>
						<!-- <el-button class="return-btn"@click="returnPage">重置</el-button> -->
					</el-form-item>
				</el-form>
			</div>

			<!-- 配送信息 -->
			<div v-else>
				<el-form :model="store" :rules="deliveryRules" ref="deliveryForm" label-width="170px">
					<el-form-item label="支持配送" prop="distribution">
						<el-radio-group v-model="store.canDelivery">
							<el-radio :label="2">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="起送价" prop="deliveryPrice">
						<el-input v-model="store.deliveryPrice" placeholder="请输入起送价" clearable
							style="width: 455px;"></el-input>
					</el-form-item>
					<el-form-item label="配送价" prop="deliveryFee">
						<el-input v-model="store.deliveryFee" placeholder="请输入配送价" clearable
							style="width: 455px;"></el-input>
					</el-form-item>

					<el-form-item>
						<el-button :loading="formLoading" class="confirm-btn"
							@click="submitForm('deliveryForm')">保存</el-button>
						<!-- <el-button class="return-btn" @click="returnPage">重置</el-button> -->
					</el-form-item>
				</el-form>
			</div>
		</div>

		<el-dialog title="地图选点" :visible.sync="mapDialogVisible" width="860px" @open="onMapDialogOpen"
			@close="onMapDialogClose">
			<div class="map-container">
				<div class="map-toolbar">
					<el-autocomplete v-model="mapSearchKeyword" class="map-search-input"
						:fetch-suggestions="fetchMapSearchSuggestions" placeholder="请输入地点关键词搜索"
						:trigger-on-focus="false" clearable @select="handleMapSearchSelect">
						<template slot-scope="{ item }">
							<div class="map-search-item-name">{{ item.name || item.value }}</div>
							<div class="map-search-item-address">{{ item.district }}{{ item.address }}</div>
						</template>
					</el-autocomplete>
				</div>
				<div class="map-board">
					<div ref="amapContainer" class="store-map"></div>
					<el-button class="map-locate-btn" size="mini" :disabled="mapLocating"
						@click="handleLocateCurrentPosition">
						定位到当前位置
					</el-button>
					<div v-if="mapLocating" class="map-center-loading">
						<i class="el-icon-loading"></i>
						<span>定位中...</span>
					</div>
				</div>
				<div class="map-tip">点击地图选择位置，系统将自动填入区域与地址</div>
				<div class="map-selected" v-if="mapSelection.address">
					已选地址：{{ mapSelection.address }}
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleMapCancel">取消</el-button>
				<el-button type="primary" @click="handleMapConfirm">确定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="公告详情" :visible.sync="noticeDetailDialogVisible" width="640px">
			<div v-if="noticeDetailLoading" class="notice-detail-loading">
				<i class="el-icon-loading" style="margin-right: 6px;"></i>公告详情加载中...
			</div>
			<div v-else-if="noticeDetail">
				<div class="notice-detail-title">{{ formatCellText(noticeDetail.title) }}</div>
				<div class="notice-detail-time">{{ formatDateTime(noticeDetail.createTime) }}</div>
				<div class="notice-detail-content">{{ formatNoticeContent(noticeDetail.content) }}</div>
			</div>
			<div v-else class="notice-detail-empty">暂无公告详情</div>
		</el-dialog>
	</div>
</template>

<script>
import {
	storeApi,
	notice
} from "@/api";
import {
	uploadFile
} from '@/api/api';
import addressJson from '@/common/address.json';
import watermarkjs from 'watermarkjs';
import {
	amapPicker
} from '@/utils/amap';

export default {
	name: 'StoreInfoEdit',
	created() {
		this.getStoreInfoDetail();
		this.getStoreTypeList();
		this.getLatestNotice();
		this.addressOptions = addressJson;

	},
	data() {
		return {
			isOnline: true,
			storeId: null,
			address: [],
			storeImageurl: '',
			licenseImageurl: '',
			addressOptions: null,
			store: {},
			storeTypeOptions: [],
			noticeLoading: false,
			noticeDetailLoading: false,
			noticeDetailDialogVisible: false,
			latestNotice: null,
			noticeDetail: null,
			mapDialogVisible: false,
			map: null,
			mapMarker: null,
			geocoder: null,
			mapAutoComplete: null,
			mapSearchKeyword: '',
			mapLocating: false,
			mapSelection: {
				provinceName: '',
				provinceCode: null,
				cityName: '',
				cityCode: null,
				districtName: '',
				districtCode: null,
				streetName: '',
				streetCode: null,
				address: '',
				lng: null,
				lat: null,
				addressPath: []
			},

			deliveryRules: {
				deliveryPrice: [{
					required: true,
					message: '请输入起送价',
					trigger: 'blur'
				}],
				deliveryFee: [{
					required: true,
					message: '请输入配送价',
					trigger: 'blur'
				}]
			},
			activeTab: 0,
			formLoading: false,
			// 回显用的 fileList（包含 url 才能显示）

			shopImgFileList: [], // 店铺图片回显
			licenseFileList: [], // 资质图片回显

			dialogImageUrl: '',
			dialogVisible: false
		};
	},
		methods: {
			openUploadDialog(type) {
				const ref = type === 'shopImg' ? this.$refs.uploadShopImg : this.$refs.uploadLicense;
				if (!ref || !ref.$el) return;
				const input = ref.$el.querySelector('input[type="file"]');
				if (input) {
					input.click();
				}
			},
			handleUploadExceed(files, fileList, type) {
				const file = files && files[0];
				if (!file) return;
				const ref = type === 'shopImg' ? this.$refs.uploadShopImg : this.$refs.uploadLicense;
				if (ref && ref.clearFiles) {
					ref.clearFiles();
				}
				if (type === 'shopImg') {
					this.shopImgFileList = [];
					this.store.imageUrl = '';
					this.storeImageurl = '';
				} else {
					this.licenseFileList = [];
					this.store.businessLicenseUrl = '';
					this.licenseImageurl = '';
				}
				this.customUploadHandler({
					file,
					onSuccess: () => {},
					onError: () => {},
					data: {
						uploadType: type === 'shopImg' ? 'shopImg' : 'license'
					}
				});
			},
		getValuesByLabels(labels, options) {
			const values = [];
			let nodes = options || [];

			for (let i = 0; i < labels.length; i += 1) {
				const label = labels[i];
				if (!label || !nodes) break;
				const node = nodes.find(item => item.label === label);
				if (!node) break;
				values.push(node.value);
				nodes = node.children;
			}
			return values;
		},
		parseDate(value) {
			if (!value) {
				return null;
			}
			if (value instanceof Date) {
				return Number.isNaN(value.getTime()) ? null : value;
			}
			if (typeof value === 'number') {
				const date = new Date(value);
				return Number.isNaN(date.getTime()) ? null : date;
			}
			if (typeof value === 'string') {
				const normalized = value.replace('T', ' ').replace(/\\.\\d+$/, '');
				const parsed = new Date(normalized.replace(/-/g, '/'));
				if (!Number.isNaN(parsed.getTime())) {
					return parsed;
				}
				const fallback = new Date(value);
				return Number.isNaN(fallback.getTime()) ? null : fallback;
			}
			return null;
		},
		formatDateTime(value) {
			if (!value) {
				return '--';
			}
			const date = this.parseDate(value);
			if (!date) {
				return this.formatCellText(value);
			}
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			const hours = String(date.getHours()).padStart(2, '0');
			const minutes = String(date.getMinutes()).padStart(2, '0');
			const seconds = String(date.getSeconds()).padStart(2, '0');
			return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
		},
		formatCellText(value) {
			return value === 0 ? 0 : (value || '--');
		},
		formatNoticeContent(content) {
			if (!content && content !== 0) {
				return '--';
			}
			return String(content).replace(/<[^>]+>/g, '').trim() || '--';
		},
		getNoticePreview(content) {
			const rawText = this.formatNoticeContent(content);
			if (rawText === '--') {
				return '--';
			}
			return rawText.length > 90 ? `${rawText.slice(0, 90)}...` : rawText;
		},
		getLatestNoticeItem(list) {
			if (!Array.isArray(list) || list.length === 0) {
				return null;
			}
			const sortedList = [...list].sort((a, b) => {
				const aTime = this.parseDate(a && a.createTime);
				const bTime = this.parseDate(b && b.createTime);
				return (bTime ? bTime.getTime() : 0) - (aTime ? aTime.getTime() : 0);
			});
			return sortedList[0] || null;
		},
		async getLatestNotice() {
			this.noticeLoading = true;
			try {
				const response = await notice.queryNoticePage({
					pageNo: 1,
					pageSize: 10,
					status: 0
				});
				if ((response.code === 0 || response.code === 200) && response.data) {
					this.latestNotice = this.getLatestNoticeItem(response.data.list);
				} else {
					this.$message.error(response.msg || '获取最新公告失败');
				}
			} catch (error) {
				console.error('获取最新公告错误:', error);
				this.$message.error('网络异常，无法获取最新公告');
			} finally {
				this.noticeLoading = false;
			}
		},
		async handleOpenNoticeDetail() {
			if (!this.latestNotice || !this.latestNotice.id) {
				return;
			}
			this.noticeDetailDialogVisible = true;
			this.noticeDetailLoading = true;
			this.noticeDetail = null;
			try {
				const response = await notice.getNoticeDetail(this.latestNotice.id);
				if ((response.code === 0 || response.code === 200) && response.data) {
					this.noticeDetail = response.data;
				} else {
					this.noticeDetail = this.latestNotice;
					this.$message.error(response.msg || '获取公告详情失败');
				}
			} catch (error) {
				console.error('获取公告详情错误:', error);
				this.noticeDetail = this.latestNotice;
				this.$message.error('网络异常，无法获取公告详情');
			} finally {
				this.noticeDetailLoading = false;
			}
		},
		// 获取店铺类别
		async getStoreTypeList() {
			try {
				const response = await storeApi.getStoreTypeList({
					pageNo: 1,
					pageSize: 100
				});
				if ((response.code === 0 || response.code === 200) && response.data?.list) {
					this.storeTypeOptions = response.data.list.map(item => ({
						label: item.storeTypeName,
						value: item.id
					}));
				} else {
					this.$message.error(response.msg || '获取店铺类别失败');
				}
			} catch (err) {
				console.error('获取店铺类别错误:', err);
				this.$message.error('网络异常，无法获取店铺类别');
			}
		},
		openMapPicker() {
			return amapPicker.openMapPicker(this);
		},
		onMapDialogOpen() {
			return amapPicker.onMapDialogOpen(this);
		},
		onMapDialogClose() {
			return amapPicker.onMapDialogClose(this);
		},
		handleMapCancel() {
			return amapPicker.handleMapCancel(this);
		},
		handleMapConfirm() {
			return amapPicker.handleMapConfirm(this);
		},
		fetchMapSearchSuggestions(queryString, cb) {
			return amapPicker.fetchMapSearchSuggestions(this, queryString, cb);
		},
		handleMapSearchSelect(item) {
			return amapPicker.handleMapSearchSelect(this, item);
		},
		handleLocateCurrentPosition() {
			return amapPicker.locateToCurrentPosition(this, {
				showLoading: true
			});
		},

		handleToggleStatus(currentStatus) {
			const targetStatus = !currentStatus;
			const actionText = targetStatus ? '上线' : '下线';
			const confirmMsg = `确定要将店铺设置为【${actionText}】状态吗？`;

			this.$confirm(confirmMsg, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false, // 点击遮罩不关闭
				closeOnPressEscape: false // 按 Esc 不关闭
			})
				.then(() => {
					// 用户点击了“确定”
					this.isOnline = targetStatus;
					this.$message({
						type: 'success',
						message: `店铺已${actionText}`
					});

					// ✅ 此处可调用 API 提交状态到服务器
					// this.updateStoreStatusToServer(this.isOnline);
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: `已取消${actionText}操作`
					});
				});
		},
		toggleStatus() {
			this.isOnline = !this.isOnline; // 切换状态
			console.log('当前状态:', this.isOnline ? '在线' : '下线');
			// 可在此处调用 API 提交状态变更
			// this.updateStoreStatus(this.isOnline);
		},
		async addWatermarkWithLib(file) {
			const outputType = file.type || 'image/png';
			const drawTiledText = (target) => {
				const ctx = target.getContext('2d');
				const width = target.width;
				const height = target.height;
				const text = '惠邻鸟';
				const font = '20px Microsoft YaHei';
				const fillStyle = 'rgba(0, 0, 0, 1)';

				ctx.save();
				ctx.globalAlpha = 0.2;
				ctx.fillStyle = fillStyle;
				ctx.font = font;
				ctx.textBaseline = 'middle';

				const metrics = ctx.measureText(text);
				const stepX = Math.max(120, Math.ceil(metrics.width + 80));
				const stepY = 120;
				const diagonal = Math.sqrt(width * width + height * height);

				ctx.translate(width / 2, height / 2);
				ctx.rotate(-Math.PI / 4);

				for (let x = -diagonal; x <= diagonal; x += stepX) {
					for (let y = -diagonal; y <= diagonal; y += stepY) {
						ctx.fillText(text, x, y);
					}
				}
				ctx.restore();
				return target;
			};

			const dataUrl = await watermarkjs([file], {
				type: outputType,
				encoderOptions: 0.92
			}).dataUrl(drawTiledText);

			const [header, base64Data] = dataUrl.split(',');
			const match = header.match(/data:(.*?);base64/);
			const mime = match ? match[1] : outputType;
			const binary = window.atob(base64Data);
			const len = binary.length;
			const bytes = new Uint8Array(len);
			for (let i = 0; i < len; i += 1) {
				bytes[i] = binary.charCodeAt(i);
			}

			return new File([bytes], file.name, {
				type: mime
			});
		},
		beforeUpload(file) {
			const isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
			if (!isImage) {
				this.$message.error('只支持 JPG/PNG 图片！');
				return false;
			}
			return true;
		},

		handleRemove(file, type) {
			if (type === 'shopImg') {
				this.store.imageUrl = '';
				this.shopImgFileList = [];
			} else if (type === 'license') {
				this.store.businessLicenseUrl = '';
				this.licenseFileList = [];
			}
		},
		async customUploadHandler({
			file,
			onSuccess,
			onError,
			data
		}) {
			const isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
			if (!isImage) {
				this.$message.error('仅支持 JPG/PNG 图片！');
				return onError(new Error('不支持的类型'));
			}

			const uploadType = data?.uploadType; // 获取类型标识
			let uploadFileObj = file;

			if (uploadType === 'license') {
				try {
					uploadFileObj = await this.addWatermarkWithLib(file);
				} catch (err) {
					this.$message.error('水印生成失败，请重新上传');
					return onError(err);
				}
			}

			const formData = new FormData();
			formData.append('file', uploadFileObj);
			formData.append('directory', uploadType === 'shopImg' ? 'pc/storeImg' : 'pc/license');

			try {
				const result = await uploadFile(formData);

				if (result.code === 0 || result.code === 200) {
					const url = result.data;

					// ✅ 根据类型设置不同字段
					if (uploadType === 'shopImg') {
						this.store.imageUrl = url;
						this.shopImgFileList = [{
							name: file.name,
							url
						}];
						this.storeImageurl = url

					} else if (uploadType === 'license') {
						this.store.businessLicenseUrl = url;
						this.licenseFileList = [{
							name: file.name,
							url
						}];
						this.licenseImageurl = url
					}

					onSuccess(result, file);
				} else {
					throw new Error(result.msg || '上传失败');
				}
			} catch (err) {
				this.$message.error(`❌ ${file.name} 上传失败：${err.message}`);
				onError(err);
			}
		},


		// 提交表单
		async submitForm(formName) {

			this.$refs[formName].validate(async (valid) => {
				if (!valid) {
					this.$message.warning('请检查表单填写是否正确');
					return false;
				}

				this.formLoading = true;
				try {
					const finalData = {
						...this.store,
						...(this.storeImageurl ? {
							imageUrl: this.storeImageurl
						} : {}),
						...(this.licenseImageurl ? {
							businessLicenseUrl: this.licenseImageurl
						} : {}),
						// id: this.storeId
					};
					console.log("表单数据", finalData)
					const response = await storeApi.cuStoreInfo(finalData);
					if (response.code === 0 || response.code === 200) {
						this.$message.success('保存成功！');
						this.getStoreInfoDetail();
					} else {
						this.$message.error(response.msg || '保存失败');
					}
				} catch (err) {
					console.error('保存错误:', err);
					this.$message.error('保存失败');
				} finally {
					this.formLoading = false;
				}
			});
		},
		isMissingStoreInfoResponse(response) {
			if (!response) {
				return false;
			}
			const success = response.code === 0 || response.code === 200;
			if (success) {
				return !response.data || response.data.id === null || response.data.id === undefined || response.data.id === '';
			}
			const msg = String(response.msg || '');
			return /(未创建|未完善|不存在).*(商家|店铺)|请先.*(创建|完善).*(商家|店铺)/.test(msg);
		},
		resetStoreInfoForCreate() {
			this.store = {
				storeName: '',
				storeTypeId: null,
				creator: '',
				contactPhoneNo: '',
				startBusinessTime: '',
				endBusinessTime: '',
				address: '',
				bulletin: '',
				imageUrl: '',
				businessLicenseUrl: '',
				provinceName: '',
				cityName: '',
				districtName: '',
				streetName: '',
				provinceCode: null,
				cityCode: null,
				districtCode: null,
				streetCode: null,
				canDelivery: 1,
				deliveryPrice: '',
				deliveryFee: ''
			};
			this.storeId = null;
			this.address = [];
			this.shopImgFileList = [];
			this.licenseFileList = [];
			this.storeImageurl = '';
			this.licenseImageurl = '';
		},
		// 获取店铺详情
		async getStoreInfoDetail() {
			const userId = this.$store.state.auth.user && this.$store.state.auth.user.userId;
			if (!userId) {
				this.$message.error('登录信息已失效，请重新登录');
				return;
			}
			try {
				const response = await storeApi.getStoreInfoDetail({
					id: userId
				});
				if ((response.code === 0 || response.code === 200) && response.data) {
					this.store = {
						...response.data,
						storeTypeId: response.data.storeTypeId ?? null
						};
						this.syncAddressFromStore();
						this.storeId = response.data.id
							// console.log("店铺数据", this.storeId)
						// 初始化已有的图片用于回显
						this.shopImgFileList = [];
						this.licenseFileList = [];
						if (this.store.imageUrl) {
							const imageUrl = this.formatUrl(this.store.imageUrl);
							this.shopImgFileList = [{
								name: 'image',
								url: imageUrl
							}];
							this.storeImageurl = this.store.imageUrl;
						}
						if (this.store.businessLicenseUrl) {
							const licenseUrl = this.formatUrl(this.store.businessLicenseUrl);
							this.licenseFileList = [{
								name: 'license',
								url: licenseUrl
							}];
						this.licenseImageurl = this.store.businessLicenseUrl;
					}
				} else if (this.isMissingStoreInfoResponse(response)) {
					this.resetStoreInfoForCreate();
					this.$message.info('当前账号还未完善商家信息，请先填写并保存');
				} else {
					this.$message.error(response.msg || '获取店铺信息失败');
				}
			} catch (err) {
				console.error('获取店铺信息异常:', err);
				this.$message.error('网络错误');
			}
		},
		handlePreviewLicense() {
			if (this.store.businessLicenseUrl) {
				this.dialogImageUrl = this.formatUrl(this.store.businessLicenseUrl); // 格式化 URL
				this.dialogVisible = true; // 弹出预览
			}
		},

		// 已有的格式化 URL 方法
		formatUrl(url) {
			if (!url) return '';
			return url.startsWith('http') ? url : `${process.env.VUE_APP_BASE_API}/${url}`.replace('//', '/');
		},

		// 原来的图片卡片预览也复用这个逻辑
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url || (file.response ? file.response.data : '');
			this.dialogVisible = true;
		},
		// 重置按钮
		returnPage() {
			this.getStoreInfoDetail();
			if (this.$refs.basicForm) {
				this.$refs.basicForm.clearValidate();
			}
			if (this.$refs.deliveryForm) {
				this.$refs.deliveryForm.clearValidate();
			}
		},
		getLabelsByValues(values, options) {
			const labels = [];

			function findPath(nodes, level = 0) {
				if (level >= values.length || !nodes) return false;

				const node = nodes.find(item => item.value === values[level]);
				if (!node) return false;

				labels.push(node.label);

				// 如果还有下一层，继续在 children 中查找
				if (node.children && level < values.length - 1) {
					return findPath(node.children, level + 1);
				}

				return true; // 找到完整路径
			}

			findPath(options, 0);
			return labels;
		},

		syncAddressFromStore() {
			if (!this.addressOptions || !this.store) return;
			const labels = [
				this.store.provinceName,
				this.store.cityName,
				this.store.districtName,
				this.store.streetName
			].filter(Boolean);
			const values = this.getValuesByLabels(labels, this.addressOptions);
			if (values.length) {
				this.address = values;
			}
		},
		handleChangeAddress(value) {
			const labels = this.getLabelsByValues(value, this.addressOptions);
			this.store.provinceName = labels[0] || '';
			this.store.cityName = labels[1] || '';
			this.store.districtName = labels[2] || '';
			this.store.streetName = labels[3] || '';
			this.store.provinceCode = value[0] ?? null;
			this.store.cityCode = value[1] ?? null;
			this.store.districtCode = value[2] ?? null;
			this.store.streetCode = value[3] ?? null;
			// console.log('选择的地址:', value);
		}
	}
};
</script>

<style scoped>
.notice-board {
	background: linear-gradient(120deg, #fff8e7 0%, #fffaf2 100%);
	border: 1px solid #ffe7ba;
	border-radius: 12px;
	padding: 14px 18px;
	box-shadow: 0 8px 20px rgba(247, 152, 0, 0.08);
}

.notice-board__header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 8px;
}

.notice-board__title {
	font-size: 16px;
	font-weight: 700;
	color: #1d2129;
}

.notice-board__time {
	font-size: 12px;
	color: #86909c;
}

.notice-board__body {
	cursor: pointer;
	background: #fff;
	border-radius: 10px;
	padding: 12px 14px;
	transition: all 0.2s ease;
}

.notice-board__body:hover {
	box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
	transform: translateY(-1px);
}

.notice-board__headline {
	font-size: 15px;
	font-weight: 600;
	color: #1d2129;
	line-height: 22px;
}

.notice-board__content {
	margin-top: 6px;
	font-size: 13px;
	color: #4e5969;
	line-height: 20px;
}

.notice-board__action {
	margin-top: 10px;
	font-size: 12px;
	color: #f79800;
	font-weight: 600;
}

.notice-board__empty {
	font-size: 13px;
	color: #86909c;
	padding: 10px 0;
}

.notice-detail-loading,
.notice-detail-empty {
	color: #86909c;
	font-size: 14px;
	line-height: 24px;
}

.notice-detail-title {
	font-size: 18px;
	font-weight: 700;
	color: #1d2129;
	line-height: 26px;
}

.notice-detail-time {
	margin-top: 8px;
	font-size: 12px;
	color: #86909c;
}

.notice-detail-content {
	margin-top: 14px;
	font-size: 14px;
	line-height: 24px;
	color: #4e5969;
	white-space: pre-wrap;
	word-break: break-word;
}

.confirm-btn {
	background-color: #F79800;
	color: #fff;
}

.return-btn {
	background-color: #F2F3F5;
	color: #000;
}

/* 设置上传卡片为 64x64 */
::v-deep .el-upload--picture-card {
	width: 64px !important;
	height: 64px !important;
	line-height: 64px !important;
	background-color: #777A7F;
	border: none;
	border-radius: 4px;
}

/* 已上传的图片项也统一尺寸 */
::v-deep .el-upload-list__item {
	width: 64px !important;
	height: 64px !important;
	border-radius: 4px;
}

/* 图片在容器内居中覆盖 */
::v-deep .el-upload-list__item img {
	object-fit: cover;
}

.address-row {
	display: flex;
	align-items: center;
	gap: 8px;
	width: 640px;
}

.address-cascader {
	width: 220px;
}

.address-input {
	flex: 1;
}

.map-toolbar {
	margin-bottom: 10px;
}

.map-search-input {
	width: 100%;
}

.map-board {
	position: relative;
}

.store-map {
	width: 100%;
	height: 420px;
}

.map-locate-btn {
	position: absolute;
	right: 14px;
	bottom: 14px;
	z-index: 2;
}

.map-center-loading {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	z-index: 3;
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 10px 14px;
	border-radius: 6px;
	background: rgba(0, 0, 0, 0.55);
	color: #fff;
	font-size: 13px;
}

.map-search-item-name {
	color: #1D2129;
	font-size: 13px;
}

.map-search-item-address {
	color: #86909C;
	font-size: 12px;
	margin-top: 2px;
}

.map-tip {
	margin-top: 8px;
	color: #86909C;
	font-size: 12px;
}

.map-selected {
	margin-top: 6px;
	color: #4E5969;
	font-size: 13px;
}

.reupload-btn {
	margin-left: 8px;
	padding: 0;
	height: 24px;
	line-height: 24px;
}
</style>
